var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { MinusIcon, PlusIcon, ReloadIcon } from '../../Components/Icons';
import { MenuButton, MenuItem } from '../../Components/MenuButton/MenuButton';
import { ListBulkAction } from '../../Contracts/MedicationListModels';
import { MedicationListStatus } from '../../Contracts/MedicationListsSearchFilter.Request';
export function MedicationListBulkActionButton(props) {
    var onBulkActionClicked = props.onBulkActionClicked, buttonProps = __rest(props, ["onBulkActionClicked"]);
    if (props.medicationList.status === MedicationListStatus.Published)
        return null;
    return (React.createElement(MenuButton, __assign({}, buttonProps, { label: 'Bulk' }), function (config) { return (React.createElement(React.Fragment, null,
        React.createElement(MenuItem, { title: 'Bulk add list items', testId: 'add', startIcon: React.createElement(PlusIcon, { size: '20' }), onClick: function () {
                config.closeMenu();
                onBulkActionClicked(ListBulkAction.Append);
            } }),
        React.createElement(MenuItem, { title: 'Bulk remove list items', testId: 'remove', startIcon: React.createElement(MinusIcon, { size: '20' }), onClick: function () {
                config.closeMenu();
                onBulkActionClicked(ListBulkAction.Remove);
            } }),
        React.createElement(MenuItem, { title: 'Sync medication list data', testId: 'sync', startIcon: React.createElement(ReloadIcon, { size: '20' }), onClick: function () {
                config.closeMenu();
                onBulkActionClicked(ListBulkAction.Sync);
            } }))); }));
}
